import classNames from 'classnames'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { CircularCheckboxWithPlayBtn } from 'components/CircularCheckboxWithPlayBtn'
import { Modal } from 'components/layout/Modal'
import { PlanTag } from 'components/planTag'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { SubtitleColorType, SubtitleType } from 'service/list'
import { Me } from 'service/user'
import { contentVideoTextTypeFormValues } from 'utils/type'
import { SelectionModal } from 'components/layout/SelectionModal'
import SubtitleToolltip from '../shortvideo/SubtitleTooltip'
import { useTranslation } from 'react-i18next'

interface SubtitleDisplayProps {
  watch: UseFormWatch<contentVideoTextTypeFormValues>
  setValue: UseFormSetValue<contentVideoTextTypeFormValues>
  control: Control<contentVideoTextTypeFormValues, any>
  translatePlanName?: (planName: string) => string
  userInfo: Me
  subTitleList: SubtitleType[] | []
  subtitleColorList: SubtitleColorType[] | []
  subtitleDivRef?: React.MutableRefObject<HTMLDivElement | null>
  setSubtitleTooltip: Dispatch<SetStateAction<boolean>>
  subtitleTooltip: boolean
}

export const SubtitleDisplay = ({
  watch,
  setValue,
  control,
  translatePlanName,
  userInfo,
  subTitleList,
  subtitleDivRef,
  setSubtitleTooltip,
  subtitleTooltip,
  subtitleColorList,
}: PropsWithChildren<SubtitleDisplayProps>) => {
  const { t } = useTranslation()
  const [isOpen, setModalOpen] = useState<boolean>(false)
  const findBgmNameById = () => {
    const [subtitle] = subTitleList.filter(
      (el) => el.id === watch('subtitleId')
    )
    const [subtitleColor] = subtitleColorList.filter(
      (el) => el?.id === watch('subtitleColorId')
    )
    return (
      <>
        <p className="flex items-center gap-1">
          <span className="bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B] rounded-[4px] text-[14px] ">
            {t('contentVideoEditor.subtitleSelection.style')}
          </span>
          <span>{subtitle?.name}</span>
        </p>
        <p className="flex items-center gap-1">
          <span className="bg-[#D9DEE8] px-1 py-[2px] text-[#8F929B] rounded-[4px] text-[14px] ">
            {t('contentVideoEditor.subtitleSelection.style')}
          </span>
          <img src={subtitleColor?.imagePath} alt="" />
        </p>
      </>
    )
  }
  const handleModalOpen = () => {
    setModalOpen((prev) => !prev)
  }

  return (
    <>
      <div className="subTitle " ref={subtitleDivRef}>
        <div className="flex md:flex-row flex-col md:items-center justify-between gap-4">
          <p className="flex font-bold text-[18px] relative items-center gap-[6px] shrink-0 w-[92px]">
            {t('contentVideoEditor.subtitleSelection.subtitle')}
            <SubtitleToolltip
              subTitleList={subTitleList}
              setSubtitleTooltip={setSubtitleTooltip}
              subtitleTooltip={subtitleTooltip}
            />
          </p>
          <p className="md:w-full w-full md:h-[61px] rounded-[10px] bg-[#F6F8FB] px-4 py-5 flex items-center justify-between font-bold">
            <div className="flex gap-4 md:flex-row flex-col ">
              {findBgmNameById()}
            </div>
            <button
              className="px-2 py-[6px] bg-[#2E343D] text-[white] rounded-[4px] text-[14px]"
              onClick={() => {
                setModalOpen((prev) => !prev)
              }}
              type="button"
            >
              {t('contentVideoEditor.subtitleSelection.select')} {'>'}
            </button>
          </p>
        </div>
      </div>
      <SelectionModal isModal={isOpen}>
        <div
          className={classNames('', {
            'bg-white md:w-[816px] h-auto  shadow-main rounded-t-[20px] px-8 pt-8  pb-28 flex flex-col   gap-8':
              !isMobile,
            'bg-white  w-full    flex flex-col   gap-8 pt-10 px-4': isMobile,
          })}
        >
          <div className="flex flex-col  gap-4  ">
            <p
              className={classNames('flex items-center', {
                'justify-center': isMobile,
                'justify-between': !isMobile,
              })}
            >
              <span className="font-bold text-[24px] text-left">{t('contentVideoEditor.subtitleSelection.title')}</span>
            </p>
            <p className="md:text-left">
              {t('contentVideoEditor.subtitleSelection.description')}
            </p>

            <div className="flex gap-2">
              <p className="flex gap-1 items-center">
                <img
                  src="assets/img/cash.png"
                  alt=""
                  className="w-[11px] h-[13px]"
                />

                <s className="text-[#5E6068]">200캐시</s>
                <span className="text-main">50캐시</span>
              </p>
            </div>
          </div>

          <div className="">
            <div className="flex flex-col gap-4 mb-8">
              <p className="font-bold text-[18px] text-left">{t('contentVideoEditor.subtitleSelection.style')}</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-[22px] gap-y-[16px] ">
                {subTitleList?.map((subtitle, index) => {
                  return (
                    <>
                      <div className="" key={`$subtitle_{index}`}>
                        <div className="flex">
                          <Controller
                            render={({ field }) => (
                              <CircularCheckbox
                                {...field}
                                id={index}
                                checked={watch('subtitleId') === subtitle?.id}
                                disabled={!userInfo}
                                onChange={() =>
                                  setValue('subtitleId', subtitle?.id)
                                }
                                label={subtitle.name}
                              />
                            )}
                            name="subtitleId"
                            control={control}
                          />
                          {new Array(subtitle?.cashRate).fill(0).map((el) => (
                            <>
                              {' '}
                              <img
                                src="assets/img/cash.png"
                                alt="cash"
                                className="w-[11px] h-[13px] ml-[2px] mt-[2px]"
                              />
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  )
                })}
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <p className="font-bold text-[18px] text-left">색상</p>
              <div className="grid grid-cols-2 md:grid-cols-4  gap-x-[22px] gap-y-[16px] ">
                {subtitleColorList?.map((subtitleColor, index) => {
                  return (
                    <>
                      <div key={index}>
                        <div className="flex">
                          <Controller
                            render={({ field }) => (
                              <CircularCheckbox
                                {...field}
                                id={index}
                                checked={
                                  watch('subtitleColorId') === subtitleColor.id
                                }
                                // disabled={watch('subtitleId') === 1}
                                onChange={() =>
                                  setValue('subtitleColorId', subtitleColor.id)
                                }
                              />
                            )}
                            name="subtitleColorId"
                            control={control}
                          />
                          <img src={subtitleColor?.imagePath} alt="" />
                        </div>
                      </div>
                    </>
                  )
                })}
              </div>
            </div>
          </div>
          {isMobile && (
            <div className="pt-5 pb-20 w-[335px]">
              <button
                className="bg-main rounded-full w-full text-white font-bold h-[60px]"
                onClick={handleModalOpen}
                type="button"
              >
                저장
              </button>
            </div>
          )}
        </div>

        {!isMobile && (
          <div
            className="sticky bottom-0 p-8 shadow-main w-full md:w-[816px] bg-white rounded-b-[20px] 
         before:content-[''] before:absolute before:top-[-10px] before:left-0 
         before:w-full before:h-[10px] before:bg-gradient-to-t before:from-black/10 before:to-transparent z-50"
          >
            <button
              className="bg-main rounded-full w-full text-white font-bold h-[60px]"
              onClick={handleModalOpen}
              type="button"
            >
              저장
            </button>
          </div>
        )}
      </SelectionModal>
    </>
  )
}
